import React from 'react'
import { Container, MainText, AreasItemsContainer, MobileAreasItemsContainer, MobileContainer } from './styles'
import AreasItem from '../AreasItem'
import useTranslateMessage from '../../../../../hooks/useTranslateMessage'
import { Hidden } from '@hermes/web-components'

const ServiceArea = () => {
  const translate = useTranslateMessage()
  return (
    <Container>
      <MainText>{translate('home-page.specialties.service')}</MainText>
      <Hidden mdDown>
        <AreasItemsContainer>
          <AreasItem icon={'HeartPulseIcon'} text={translate('specialists')} />
          <AreasItem icon={'ClinicIcon'} text={translate('practices')} />
          <AreasItem icon={'DentistIcon'} text={translate('dentist')} />
          <AreasItem icon={'HospitalIcon'} text={translate('hospitals')} />
          <AreasItem icon={'CareHomeIcon'} text={translate('care-home')} />
          <AreasItem icon={'PharmaciesIcon'} text={translate('pharmacies')} />
          <AreasItem icon={'HomeCareSpecIcon'} text={translate('home-care-one')} />
        </AreasItemsContainer>
      </Hidden>
      <Hidden mdUp>
        <MobileContainer>
          <MobileAreasItemsContainer>
            <AreasItem icon={'HeartPulseIcon'} text={translate('specialists')} />
            <AreasItem icon={'ClinicIcon'} text={translate('practices')} />
            <AreasItem icon={'DentistIcon'} text={translate('dentist')} />
            <AreasItem icon={'HospitalIcon'} text={translate('hospitals')} />
          </MobileAreasItemsContainer>
          <MobileAreasItemsContainer>
            <AreasItem icon={'CareHomeIcon'} text={translate('care-home')} />
            <AreasItem icon={'PharmaciesIcon'} text={translate('pharmacies')} />
            <AreasItem icon={'HomeCareSpecIcon'} text={translate('home-care-one')} />
          </MobileAreasItemsContainer>
        </MobileContainer>
      </Hidden>
    </Container>
  )
}

export default ServiceArea
